<div class="payment-method-card">
    <div class="payment-method-card__left">
        <div class="payment-method-card__title" [class.no-label]="!formattedLabel">{{ title }}</div>
        <div class="payment-method-card__label" *ngIf="formattedLabel">{{ formattedLabel }}</div>
    </div>
    <div class="payment-method-card__image">
        <img [src]="imageSource" alt="Payment Method Icon" />
    </div>
</div>